/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  BboDeclarationBadRequestResponse,
  BboDeclarationFailureResponseResponse,
  ForbiddenResponse,
  GetBpTpListFiltersParams,
  GetBpTpListFiltersResponseResponse,
  UnauthorizedResponse,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * Get BP TP List filters
 * @summary Get All filters for BP TP list
 */
export const getBpTpListFilters = (params?: GetBpTpListFiltersParams, signal?: AbortSignal) => {
  return customInstance<GetBpTpListFiltersResponseResponse>({
    url: `/bm-declaration-service/v1/bp-tp/filters`,
    method: 'get',
    params,
    signal,
  });
};

export const getGetBpTpListFiltersQueryKey = (params?: GetBpTpListFiltersParams) => {
  return [`/bm-declaration-service/v1/bp-tp/filters`, ...(params ? [params] : [])] as const;
};

export const getGetBpTpListFiltersQueryOptions = <
  TData = Awaited<ReturnType<typeof getBpTpListFilters>>,
  TError = ErrorType<
    | BboDeclarationBadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | BboDeclarationFailureResponseResponse
  >,
>(
  params?: GetBpTpListFiltersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getBpTpListFilters>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetBpTpListFiltersQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getBpTpListFilters>>> = ({ signal }) =>
    getBpTpListFilters(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getBpTpListFilters>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetBpTpListFiltersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBpTpListFilters>>
>;
export type GetBpTpListFiltersQueryError = ErrorType<
  | BboDeclarationBadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | BboDeclarationFailureResponseResponse
>;

/**
 * @summary Get All filters for BP TP list
 */
export const useGetBpTpListFilters = <
  TData = Awaited<ReturnType<typeof getBpTpListFilters>>,
  TError = ErrorType<
    | BboDeclarationBadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | BboDeclarationFailureResponseResponse
  >,
>(
  params?: GetBpTpListFiltersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getBpTpListFilters>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBpTpListFiltersQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
